// extracted by mini-css-extract-plugin
export default {"container":"infoComp_container__60yUl"};